import { gql } from "graphql-request";

// `ItemId` is not selected: this schema declares its own `itemId` field, which
// hides the system one, so asking for `ItemId` fails the whole query. The row is
// identified by `OrganizationId` (there is one row per organization).
export const GET_ORGANIZATION_CONFIGS = gql`
  query GetOrganizationConfigs(
    $where: organizationconfigFilterInput
    $order: [DynamicSortInput!]
    $pageNo: Int!
    $pageSize: Int!
  ) {
    getorganizationconfigs(
      where: $where
      order: $order
      paging: { pageNo: $pageNo, pageSize: $pageSize }
    ) {
      totalCount
      totalPages
      hasNextPage
      hasPreviousPage
      items {
        CreatedDate
        CreatedBy
        LastUpdatedDate
        LastUpdatedBy
        Language
        OrganizationId
        Tags
        DeletedDate
        orgLogo
      }
    }
  }
`;

export const GET_ORGANIZATION_COLOR = gql`
  query GetOrganizationColor($where: organizationconfigFilterInput) {
    getorganizationconfigs(where: $where) {
      items {
        primaryColor 
      }
    }
  }
`;

export const INSERT_ORGANIZATION_CONFIG = gql`
  mutation InsertOrganizationConfig($orgLogo: String) {
    insertorganizationconfig(input: { orgLogo: $orgLogo }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// The org config row is targeted by its OrganizationId, not ItemId — there is one
// config per organization. graphql.client's auto-scoping sees OrganizationId
// already present in `where` and leaves these alone.
export const UPDATE_ORGANIZATION_CONFIG = gql`
  mutation UpdateOrganizationConfig(
    $organizationId: String!
    $orgLogo: String
  ) {
    updateorganizationconfig(
      where: { OrganizationId: { eq: $organizationId } }
      input: { orgLogo: $orgLogo }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const DELETE_ORGANIZATION_CONFIG = gql`
  mutation DeleteOrganizationConfig($organizationId: String!) {
    deleteorganizationconfig(
      where: { OrganizationId: { eq: $organizationId } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_ORGANIZATION_COLOR = gql`
  mutation UpdateOrganizationColor(
    $organizationId: String!
    $primaryColor: String
  ) {
    updateorganizationconfig(
      where: { OrganizationId: { eq: $organizationId } }
      input: { primaryColor: $primaryColor }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

